export default __webpack_public_path__ + "static/2.5.2/media/noFundsModal.97213aef.svg";